export default __webpack_public_path__ + "static/media/pg-4.3bfcc9e5.jpg";